import EllaPrompt from '@/components/common/Ella/EllaPrompt';
import { EllaPromptObject } from '@/types/Ella';

export type TryAgainCTAProps = {
  handlePromptClick: (e: any, prompt: EllaPromptObject) => void;
};

export function TryAgainCTA(props: TryAgainCTAProps) {
  const { handlePromptClick } = props;

  return (
    <>
      <EllaPrompt
        className='Button EllaMessages-product-btn-alt'
        key={`prompt-try-again`}
        prompt={{
          prompt: 'Try again',
          assistant: 'Same configuration as last user messages'
        }}
        onClick={(e: any) => {
          handlePromptClick(e, {
            prompt: 'Try again',
            assistant: 'Same configuration as last user messages'
          });
        }}
      />
    </>
  );
}
